import { Link } from 'react-router-dom';
import { heroData } from '@/mocks/homeData';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center overflow-hidden bg-background-100">
      <div className="absolute inset-0">
        <img
          src={heroData.image}
          alt="51爆料今日热点大瓜独家速报"
          className="w-full h-full object-cover object-top"
          title="51爆料今日热点大瓜独家速报"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-start lg:items-center gap-8 lg:gap-16 pt-20 pb-12 md:pt-24 md:pb-16">
          <div className="flex-1">
            <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl xl:text-8xl font-black text-background-50 leading-tight tracking-tight">
              {heroData.title}
              <br />
              <span className="text-accent-500">{heroData.subtitle}</span>
            </h1>
          </div>

          <div className="flex-1 lg:pt-4">
            <p className="text-background-50/70 text-sm md:text-base leading-relaxed mb-6 max-w-md">
              {heroData.description}
            </p>
            <Link
              to={heroData.ctaLink}
              className="group inline-flex items-center gap-2 text-accent-500 font-semibold text-sm md:text-base hover:text-accent-400 transition-colors cursor-pointer"
            >
              {heroData.ctaText}
              <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 px-4 md:px-6 pb-6 md:pb-8">
        <div className="w-full h-[180px] md:h-[280px] lg:h-[360px] rounded-2xl overflow-hidden">
          <img
            src={heroData.image}
            alt="51爆料独家速报封面"
            className="w-full h-full object-cover object-top"
            title="51爆料独家速报封面"
          />
        </div>
      </div>
    </section>
  );
}